export enum EnumTpProduto {
    Produto = 0,
    ProdutoComSubItem = 1,
    Combo = 2,
    Insumo = 3,
    Opcional = 4,
    Adicional = 5,
    Medicamento = 6
}